import React from 'react';
import { useNavigate } from 'react-router-dom';
// --- (NEW) Import your logo image ---
import logo from '../assets/images/hjlogo.png'; 

const Header = ({ title, showBackButton = false }) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <header className="header-outer">
      <div className="header-inner">
        <div className="header-side-left">
          {showBackButton ? (
            <button 
              onClick={handleGoBack} 
              className="material-icons header-icon-button"
            >
              arrow_back
            </button>
          ) : (
            // --- (FIX) Replaced icon with image logo ---
            <img src={logo} alt="Site Logo" className="header-logo-img" />
          )}
        </div>

        <div className="header-center">
          <h1 className="header-title">{title}</h1>
        </div>

        <div className="header-side-right">
            {/* --- (FIX) Replaced icon with image logo --- */}
           <img src={logo} alt="Site Logo" className="header-logo-img" />
        </div>
      </div>
    </header>
  );
};

export default Header;